module.exports = __webpack_public_path__ + "img/bannerText.a89eec20.png";